import { CommonModule } from "@angular/common";
import { Component, ElementRef, EventEmitter, Inject, OnInit, Output, ViewChild } from "@angular/core";
import { FormControl, FormGroup, FormsModule, ReactiveFormsModule, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialog } from "@angular/material/dialog";
import { PopupCloseMode } from "@features/control-points/models/popupMode";
import { NgSelectComponent } from "@ng-select/ng-select";
import { TranslateModule, TranslateService } from "@ngx-translate/core";
import { CurrentStateService } from "app/core/services/current-state.service";
import { Subject, takeUntil } from "rxjs";
import { Company } from "@shared/models/company";
import { Organization } from "@shared/models/organization";
import { Country } from "@shared/models/country";
import { CompanyService } from "../../services/company.service";
import { FonctionsService } from "@shared/services/utilities/fonctions.service";

@Component({
  selector: 'app-popup-company',
  imports: [
    CommonModule,
    ReactiveFormsModule,
    FormsModule,
    TranslateModule,
    NgSelectComponent
  ],
  templateUrl: './company-modal.component.html',
  styleUrl: './company-modal.component.scss'
})

export class CompanyModaleComponent implements OnInit {
  @ViewChild('popup') popup!: ElementRef;
  @Output() close = new EventEmitter<PopupCloseMode>();
  organizations : Organization[] = [];
  countries : Country[] = [];
  private unsubscribe$ = new Subject<void>();
  protected isNew: boolean = false;
  selectedCompany: Company;
  protected form: FormGroup  | undefined;
    constructor(
      protected currentStateService: CurrentStateService,
      private dialog: MatDialog,
      private companyService: CompanyService,
      private fonctionsService: FonctionsService,
      private translate: TranslateService,
      @Inject(MAT_DIALOG_DATA) public data: any,
    ) {
          this.form = new FormGroup({
          name: new FormControl(null, [Validators.required]),
          countryId: new FormControl(null, [Validators.required]),
          managingOrganizationId: new FormControl(null, [Validators.required]),
        });
        
  
      this.currentStateService.closePopup$.pipe(takeUntil(this.unsubscribe$)).subscribe({
        next: (closeMode: PopupCloseMode | null) => {
          if (closeMode != null && closeMode === PopupCloseMode.CLOSE) {
            this.onClose(closeMode);
          }
        }
      });
    }

    ngOnInit(): void {
        this.isNew = this.data?.isNew;
        this.organizations = this.data?.organizations;
        this.countries = this.data?.countries;
        this.selectedCompany = this.data?.company;
        if (this.selectedCompany) {
            this.form.reset();
            this.patchFormFromSelectedCompany();
          }
    }
    protected onClose(closeMode: PopupCloseMode = PopupCloseMode.CLOSE) {
        this.close.emit(closeMode);
        this.dialog.closeAll();
      }

      onSubmit(): void {
        this.form.markAllAsTouched();
        if (this.form.invalid) {
            return;
        }
        if (this.isNew) {
            this.companyService.createCompany(this.getCompanyDataFromForm()).subscribe({
                next: () => {
                    this.onClose(PopupCloseMode.CLOSE);
                    this.fonctionsService.launch_toast(true, this.translate.instant('SUCCESS.COMPANY_SAVED'));
                },
                error: () => {
                    this.fonctionsService.launch_toast(true, this.translate.instant('ERRORS.FAILED_TO_SAVE_COMPANY'));
                }
            });
        } else {
            this.companyService.updateCompany(this.getCompanyDataFromForm()).subscribe({
                next: () => {
                    this.onClose(PopupCloseMode.CLOSE);
                    this.fonctionsService.launch_toast(true, this.translate.instant('SUCCESS.COMPANY_SAVED'));
                },
                error: () => {
                    this.fonctionsService.launch_toast(true, this.translate.instant('ERRORS.FAILED_TO_SAVE_COMPANY'));
                }
            });
        }
    }

        getCompanyDataFromForm(): Company {
          const formValue = this.form.value;
        
          const company: Company = {
            id: this.selectedCompany?.id || 0,
            managingOrganizationId: formValue.managingOrganizationId,
            name: formValue.name,
            countryId: formValue.countryId,
            nbUsers: 0,
            userName: [],

          };
          return company;
        }
        private patchFormFromSelectedCompany(): void {
            if (this.selectedCompany) {
              this.form.patchValue({
                name: this.selectedCompany.name || null,
                managingOrganizationId: this.selectedCompany.managingOrganizationId || null,
                countryId: this.selectedCompany.countryId || null,
              });
            }
          }
}